import addFormats from 'ajv-formats'
import Ajv8, {ErrorObject as ErrorObjectV8, Options as OptionsV8} from 'ajv'
import ajv6, {Ajv as Ajv6, ErrorObject as ErrorObject6, Options as OptionsV6} from 'ajv-6'
import {experiment} from '@wix/dm-experiments'

export type ErrorObject = ErrorObject6 | ErrorObjectV8
export type Options = OptionsV6 | OptionsV8
export type Ajv = Ajv8 | Ajv6

export const createInstance = (ajvOptions: Options = {}) => {
    if (experiment.isOpen('dm_shouldUseOldAjvVersion')) {
        return ajv6(ajvOptions as OptionsV6)
    }

    const ajvInstance = new Ajv8(ajvOptions as OptionsV8)
    addFormats(ajvInstance)
    return ajvInstance
}
